__turbopack_context__.v({
  "replayButton": "S8WzIG_replayButton",
  "videoWrapper": "S8WzIG_videoWrapper",
});
